import { useMemo } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { AGENCY_AD_PLATFORM_OPTIONS } from "../../../utils/constants";
import {
  PRE_ACTIVATION_FIELD_AGENCY_ACTIVE_BRANDS_COUNT,
  PRE_ACTIVATION_FIELD_AGENCY_AD_PLATFORMS,
  PRE_ACTIVATION_FIELD_AGENCY_PLATFORM_USERS_COUNT,
  PRE_ACTIVATION_HINT_AGENCY_ACTIVE_BRANDS_COUNT,
  PRE_ACTIVATION_HINT_AGENCY_PLATFORM_USERS_COUNT,
  PRE_ACTIVATION_PLACEHOLDER_AGENCY_ACTIVE_BRANDS_COUNT,
  PRE_ACTIVATION_PLACEHOLDER_AGENCY_PLATFORM_USERS_COUNT,
} from "../../../i18n/keysTranslations";
import CheckGroup from "../components/CheckGroup";
import FieldBlock from "../components/FieldBlock";
import FieldError from "../components/FieldError";
import FieldHint from "../components/FieldHint";
import FieldLabel from "../components/FieldLabel";
import IntakeTextField from "../../../components/Form/IntakeTextField";
import ReadOnlySectionGrid from "../components/ReadOnlySectionGrid";

const AgencyBasicsSection = ({ control, errors, readOnly }) => {
  const { t } = useTranslation();

  const agencyAdPlatformOptions = useMemo(
    () =>
      AGENCY_AD_PLATFORM_OPTIONS.map((option) => ({
        value: option.value,
        label: t(option.labelKey),
      })),
    [t]
  );

  return (
    <ReadOnlySectionGrid readOnly={readOnly}>
      <FieldBlock>
        <FieldLabel
          htmlFor="activeBrandsCount"
          text={t(PRE_ACTIVATION_FIELD_AGENCY_ACTIVE_BRANDS_COUNT)}
          required
        />
        <FieldHint text={t(PRE_ACTIVATION_HINT_AGENCY_ACTIVE_BRANDS_COUNT)} />
        <IntakeTextField
          name="activeBrandsCount"
          control={control}
          rules={{}}
          errors={errors}
          fullWidth
          readOnly={readOnly}
          placeholder={t(PRE_ACTIVATION_PLACEHOLDER_AGENCY_ACTIVE_BRANDS_COUNT)}
          variant="outlined"
        />
      </FieldBlock>

      <FieldBlock>
        <FieldLabel
          htmlFor="platformUsersCount"
          text={t(PRE_ACTIVATION_FIELD_AGENCY_PLATFORM_USERS_COUNT)}
          required
        />
        <FieldHint text={t(PRE_ACTIVATION_HINT_AGENCY_PLATFORM_USERS_COUNT)} />
        <IntakeTextField
          name="platformUsersCount"
          control={control}
          rules={{}}
          errors={errors}
          fullWidth
          readOnly={readOnly}
          placeholder={t(
            PRE_ACTIVATION_PLACEHOLDER_AGENCY_PLATFORM_USERS_COUNT
          )}
          variant="outlined"
        />
      </FieldBlock>

      <FieldBlock>
        <FieldLabel
          htmlFor="agencyAdPlatforms"
          text={t(PRE_ACTIVATION_FIELD_AGENCY_AD_PLATFORMS)}
          required
        />
        <Controller
          name="agencyAdPlatforms"
          control={control}
          render={({ field, fieldState }) => (
            <>
              <CheckGroup
                name="agencyAdPlatforms"
                options={agencyAdPlatformOptions}
                selectedValues={field.value}
                onChange={field.onChange}
                readOnly={readOnly}
              />
              <FieldError message={fieldState.error?.message} />
            </>
          )}
        />
      </FieldBlock>
    </ReadOnlySectionGrid>
  );
};

export default AgencyBasicsSection;
